module.exports = __webpack_public_path__ + "img/zixun.09e72e73.png";